<template>
  <div class="login">
    <b-container>
      <div v-if="!OTP && !OTPConfirmed">
        <h2 class="section-heading">Recruitment Portal</h2>
        <p class="text-center mt-4">Please enter your email address and password below. If verified, a One Time Passcode will be sent to your email address.</p>
        <b-row>
          <b-col>
            <div class="login-card">
              <b-form>
                <!-- Username -->
                <label class="input-label">Email</label>
                <b-form-group
                >
                  <b-form-input
                    type="email"
                    
                    v-model="$v.user.email.$model"
                  ></b-form-input>
                </b-form-group>
                <!-- Password -->
                <label class="input-label">Password</label>
                <b-input-group
                >
                  <b-form-input
                   
                    v-model="$v.user.password.$model"
                    :type="passwordType"
                    class="password-input"
                  ></b-form-input>
                  <b-input-group-prepend 
                  is-text
                  @click="toggleShowPassword()"
                  class="password-icon-wrapper"
                  >
                  <b-icon
                  font-scale="1.5"
                  :icon="passwordType === 'password' ? 'eye-fill': 'eye-slash-fill'"
                   />
                  </b-input-group-prepend>
                </b-input-group>
                <b-form-group>
                  <BtnMain
                    @btnClicked="handleRegistrationUpdateLogin"
                    text="Login"
                    btnClass="login-btn mt-4"
                    variant="success" 
                  />
                </b-form-group>
                <b-form-group v-if="successAlert || errorAlert">
                <b-alert
                  show
                  :variant="successAlert ? 'success' : 'danger'"
                >
                  <p>{{ alertMsg }}</p>
                </b-alert>
              </b-form-group>
              </b-form>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="OTP && !OTPConfirmed">
        <h2 class="section-heading">Enter Code</h2>
        <p class="text-center mt-5">Please enter the One Time Passcode that was sent to your email address</p>
        <b-row>
          <b-col>
            <div class="login-card">
              <b-form>
                <!-- password -->
                <b-form-group
                  label="Code"
                >
                  <b-form-input
                    :class="{
                      'is-valid': !$v.user.code.$error && user.code,
                      'is-invalid': $v.user.code.$error && $v.user.code.$dirty
                    }"
                    v-model="$v.user.code.$model"
                    @input="(val) => (user.code = user.code.toUpperCase())"
                    type="text"
                  ></b-form-input>
                </b-form-group>
             
                <b-form-group>
                  <BtnMain @btnClicked="handleRegistrationOTPCheck"
                    text="Confirm Code"
                    btnClass="confirm-btn mt-4"
                    variant="success"
                  />
                </b-form-group>
              </b-form>
              <b-form-group v-if="successAlert || errorAlert">
                <b-alert
                  show
                  :variant="successAlert ? 'success' : 'danger'"
                >
                  <p>{{ alertMsg }}</p>
                </b-alert>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="OTPConfirmed">
        <h2 class="section-heading">Update your phone number</h2>
        <b-row>
          <b-col>
            <div class="login-card">
              <b-form>
                <!-- password -->
                <b-form-group
                  label="Mobile Number"
                >
                  <b-form-input
                    :class="{
                      'is-valid': !$v.user.phoneMob.$error && user.phoneMob,
                      'is-invalid': $v.user.phoneMob.$error && $v.user.phoneMob.$dirty
                    }"
                    v-model="$v.user.phoneMob.$model"
                    type="text"
                  ></b-form-input>
                </b-form-group>
             
                <b-form-group>
                  <BtnMain @btnClicked="handleRegistrationDetailsUpdate"
                    text="Update Phone Number"
                    btnClass="confirm-btn mt-4"
                    variant="success"
                  />
                </b-form-group>
              </b-form>
                <b-form-group v-if="successAlert || errorAlert">
                <b-alert
                  show
                  :variant="successAlert ? 'success' : 'danger'"
                >
                  <p>{{ alertMsg }}</p>
                </b-alert>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  import { requiredIf, email } from 'vuelidate/lib/validators'
  import BtnMain from '@/components/BtnMain'
  import { updateRegistrationLogin, updateRegistrationOTPCheck, registrationDetailsUpdate } from '@/services/api'
  export default {
    components: {
      BtnMain
    },
    data () {
      return {
        user: {
          email: '',
          password: '',
          code: '',
          phoneMob: ''
        },
        successAlert: false,
        errorAlert: false,
        alertMsg: '',
        passwordType: 'password',
        OTP: false,
        OTPConfirmed: false
      }
    },
    methods: {
      async handleRegistrationUpdateLogin () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          const loginData = {
            email: this.user.email,
            password: this.user.password
          }
          const res = await updateRegistrationLogin(loginData)
          if (res && res.data && res.data.success) {
            this.successAlert = true
            this.alertMsg = 'Email and Password Verified, please check your email for your One Time Passcode'
            setTimeout(() => {
              this.OTP = true
              this.successAlert = false
              this.alertMsg = ''
            }, 3000)
          } else {
            this.errorAlert = true
            this.alertMsg = 'Login Failed'
            setTimeout(() => {
              this.errorAlert = false
              this.alertMsg = ''
            }, 3000)
          }
        } else {
          this.errorAlert = true
          this.alertMsg = 'Please complete all fields'
          setTimeout(() => {
            this.errorAlert = false
            this.alertMsgMsg = ''
          }, 3000)
        }
      },
      async handleRegistrationOTPCheck () {
        const codeData = {
          code: this.user.code
        }
        const token = localStorage.getItem('token')
        const res = await updateRegistrationOTPCheck(token, codeData)
        if (res && res.data && res.data.success) {
          this.user.phoneMob = res.data.phoneMob
          this.successAlert = true
          this.alertMsg = 'Code matched, you will now be able to update your phone number'
          setTimeout(() => {
            this.OTPConfirmed = true
            this.successAlert = false
            this.alertMsg = ''
          }, 3000)
        } else {
          this.errorAlert = true
          this.alertMsg = 'Code does not match, please try again'
          setTimeout(() => {
            this.errorAlert = false
            this.alertMsg = ''
          }, 3000)
        }
      },
      async handleRegistrationDetailsUpdate () {
        const phoneMobData = {
          phoneMob: this.user.phoneMob
        }

        const token = localStorage.getItem('token')
        const res = await registrationDetailsUpdate(token, phoneMobData)
        if (res && res.data && res.data.success) {
          this.successAlert = true
          this.alertMsg = 'Phone number successfully updated, you should now recieve a code that you can enter in the next screen to complete your registration'
          setTimeout(() => {
            this.successAlert = false
            this.alertMsg = ''
            this.$router.push('/confirm-phone')
          }, 5000)
        } else {
          this.errorAlert = true
          this.alertMsg = 'Error updating details'
          setTimeout(() => {
            this.errorAlert = false
            this.alertMsg = ''
          }, 3000)
        }
      },
      toggleShowPassword(){
        this.passwordType === 'password'? this.passwordType = 'text' : this.passwordType = 'password'
      },
    },
    validations: {
    user: {
      email: {
        required: requiredIf(function() {
          return !this.OTP && !this.OTPConfirmed
        }),
        email: email
      },
      password: {
        required: requiredIf(function() {
          return !this.OTP && !this.OTPConfirmed
        }),
      },
      code: {
        required: requiredIf(function() {
          return this.OTP && !this.OTPConfirmed
        }),
      },
      phoneMob: {
        required: requiredIf(function() {
          return this.OTPConfirmed
        }),
      }
    }
  }
  }
</script>

<style>
.password-icon-wrapper {
  cursor: pointer;
}
</style>